export default "__VITE_ASSET__B24j56Uf__"